/**
 * 所有应用视图
 */
export const viewstate: any = {
    appviews: [
        {
            viewtag: '0323660a827a0a485b63d847da7c9746',
            viewmodule: 'smt',
            viewname: 'WoSmVisitTaskEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '0aca3b1921d103dd21174e9a28b9970e',
            ],
        },
        {
            viewtag: '03309023e72ec42a0df67de1698b013e',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '052de6cc43f3333159d35381c8150133',
            viewmodule: 'wkd',
            viewname: 'WoMeasureUsr2EditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'ade28c7624eda179a621c29515511b81',
            ],
        },
        {
            viewtag: '08c839f24ce19e185c72c58ae9d06b44',
            viewmodule: 'smt',
            viewname: 'WoSmClaimsInfoEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '0aca3b1921d103dd21174e9a28b9970e',
            viewmodule: 'smt',
            viewname: 'WoSmVisitTaskGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '24fc35b6e663efbc438a85d34aaa81e9',
            ],
        },
        {
            viewtag: '0bbee0afa88f63b28bddf3f919f15d88',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderUsr5GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '03309023e72ec42a0df67de1698b013e',
            ],
        },
        {
            viewtag: '0cd08cee66aa03c05a23fd72354a6585',
            viewmodule: 'smt',
            viewname: 'WoSmSurchargesGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'a743fc83f49be525940bdc842076f940',
                '831612175f2e92c9aaffa360ff829bcf',
                '8234a596c7a9941e5bdd04dd26480190',
            ],
        },
        {
            viewtag: '0e2f6d1133c650ec64e7d20e7c6686eb',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderUsr2EditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '2ff4acc27a8fc798cb9be4236e556276',
                '7b5cb08b4bee366b659dc2c4517b1144',
                '81f2d4928d038339a935ab3028a2a2b7',
                '9a4fe62fb7e5da7f2ff10f9eb790cef7',
                'a6503c88a8ce448eea4d15e5bd2ed191',
                'a968d96a82ca712efd9f6b0d17742cbb',
                'f36b235f97cf06984864f4d32e9f3bdf',
                'e90c9767da6c3887a4775b1d2edcb42d',
            ],
        },
        {
            viewtag: '0e65c6512b8018de3acb5f5a006e0c6a',
            viewmodule: 'wkd',
            viewname: 'BdUserAssetArchievesEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '13bc1d9ad5497825320106f324998347',
            viewmodule: 'wkd',
            viewname: 'WoSmInfoSmInfoGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '3a058e620932eb84d4d6e60e6f8931e9',
                'ab92960e171e985d50aae9e7e29d0c9f',
                'ebaf4b76909b521b9bef4e9f4f5b94e3',
            ],
        },
        {
            viewtag: '14b84cf2d196dbbbba2ab3864eb6d12b',
            viewmodule: 'wkd',
            viewname: 'WoMessageInfoEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '1919d66c4c7c514cec8f5ea02c888f43',
            viewmodule: 'wkd',
            viewname: 'WoMaterialDetailedUsr2GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '66e083bfe46d2e2bd27f57392965461d',
            ],
        },
        {
            viewtag: '19879b6e59b9477a0279bbb0f0b45481',
            viewmodule: 'wkd',
            viewname: 'WoMaterialDetailedUsr3GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '66e083bfe46d2e2bd27f57392965461d',
            ],
        },
        {
            viewtag: '1a6bc0f6ab34f11fbe95a5a3b1835a36',
            viewmodule: 'smt',
            viewname: 'WoSmStimulateAppealApplyEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '1b3e0f4c3b3a4fb9a3db4552eaf83b6d',
            viewmodule: 'smt',
            viewname: 'WoSmStimulateStimulateInfoGrid',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '1a6bc0f6ab34f11fbe95a5a3b1835a36',
                'b9e8181396c15df37c58a532cb8fd50d',
            ],
        },
        {
            viewtag: '2324959ee82cea859dc4f82342991e38',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderUsr4EditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '23c0a4ba3064c6d5b0d0ac2002c61b29',
            viewmodule: 'smt',
            viewname: 'WoSmVisitTaskUsr4EditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '244200b1f065659f0fb553e4f7974d17',
            viewmodule: 'wkd',
            viewname: 'BdCustomerPickupGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '24fc35b6e663efbc438a85d34aaa81e9',
            viewmodule: 'smt',
            viewname: 'WoSmVisitTaskUsr6GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '2815cc6561a19adbf64098350ceca53f',
            viewmodule: 'smt',
            viewname: 'WoSmClaimsInfoBasicEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '4d96395425de9c188ccd346a67854029',
                '08c839f24ce19e185c72c58ae9d06b44',
            ],
        },
        {
            viewtag: '2cdd13d27ddaf16f6d85680b39accdf0',
            viewmodule: 'wkd',
            viewname: 'BdCustomerPickupView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '244200b1f065659f0fb553e4f7974d17',
            ],
        },
        {
            viewtag: '2e41d1fde62f9bc93987fa2287bb14a7',
            viewmodule: 'smt',
            viewname: 'WoSmTicketGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'ab92960e171e985d50aae9e7e29d0c9f',
            ],
        },
        {
            viewtag: '2ff4acc27a8fc798cb9be4236e556276',
            viewmodule: 'wkd',
            viewname: 'WoClientContactGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '97e8aa4565ee59f15cfa6cfc2d7da69a',
            ],
        },
        {
            viewtag: '32e94148efa844fb2e0ba14d034cd2d4',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderPickupView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '817be7891afd2adb7109c77c1d8af647',
            ],
        },
        {
            viewtag: '381cd6bff30cbf2aa0df3c9c11f30a2c',
            viewmodule: 'smt',
            viewname: 'WoSmStimulateGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'b9e8181396c15df37c58a532cb8fd50d',
            ],
        },
        {
            viewtag: '3a058e620932eb84d4d6e60e6f8931e9',
            viewmodule: 'smt',
            viewname: 'WoSmInfoSmInfoAgentEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'ac2c0be8d0abd3b33efff8d6a5c2142a',
                'b1e735452b86e7aa6ade7afc476e39f9',
            ],
        },
        {
            viewtag: '3a27294878f2839cd20ab3d30e1acbed',
            viewmodule: 'smt',
            viewname: 'WoSmStimulateStimulateApplyEdit',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '7233ba909c69c9be52f7329658736d81',
                '381cd6bff30cbf2aa0df3c9c11f30a2c',
            ],
        },
        {
            viewtag: '3c01c80f3ec22a05d4177246580084e1',
            viewmodule: 'wkd',
            viewname: 'WoProdUsr6GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'ce9432ad2176d15650482de6c093f1b3',
            ],
        },
        {
            viewtag: '3e0b619bac84457a7589091d32c60a93',
            viewmodule: 'wkd',
            viewname: 'WoServiceSuperviseGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '55966deb46528f951ad5bd99ee6d15a7',
            ],
        },
        {
            viewtag: '4564cf64854f382d4593c381fad98d9d',
            viewmodule: 'smt',
            viewname: 'WoSmVisitTaskUsr4GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '665c668be0f2eb77a97308f06d3ffe8a',
                '23c0a4ba3064c6d5b0d0ac2002c61b29',
            ],
        },
        {
            viewtag: '4d96395425de9c188ccd346a67854029',
            viewmodule: 'smt',
            viewname: 'WoSmClaimsGoodsGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'ccef7528f013b8bb6aa49b8d91fb3457',
            ],
        },
        {
            viewtag: '500ae2900da9f583d75f6b130052e465',
            viewmodule: 'smt',
            viewname: 'WoSmVisitTaskUsr2GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'a1863f3a17f6d72856c9e2af55d4294a',
                '665c668be0f2eb77a97308f06d3ffe8a',
                'b27cec60bcf15a1d271214405714efc5',
            ],
        },
        {
            viewtag: '5018f179ea8c1791b1fcad1e329f0fbe',
            viewmodule: 'wkd',
            viewname: 'WoSpareInfoUsr2GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '59dc621409a73d07094c660eb0f26385',
            ],
        },
        {
            viewtag: '5343f8a488c42f2371bff99be1bf3701',
            viewmodule: 'wkd',
            viewname: 'WoProcessHistoryUsr3GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'bfc401004306ea33b92652f287426f8d',
            ],
        },
        {
            viewtag: '55560682b2fe4c5c67cbef7be03c2ebf',
            viewmodule: 'wkd',
            viewname: 'csswkd',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '71d8ba694acfa4f070a9b992d34379a4',
                '0323660a827a0a485b63d847da7c9746',
                'a06dedb0979c28d6243c7fff309eb5d2',
                '8a30070e5e5e6f69d1b31baac242d239',
                '0cd08cee66aa03c05a23fd72354a6585',
                '6649103bdf9465e168c517a9a0d75380',
                '3a27294878f2839cd20ab3d30e1acbed',
                '0bbee0afa88f63b28bddf3f919f15d88',
                'cce7be02b8c2e542c7553397013e8bd6',
                '13bc1d9ad5497825320106f324998347',
                '1b3e0f4c3b3a4fb9a3db4552eaf83b6d',
                '79e6fd53665e34c79195010bae3238a5',
                'b5e161e5ef5596fdbbb066dda65fb93b',
                '61451de2399645a6f0bac4a3185248f3',
                'eaa3d8c1504ff9323b3a9b04339a938c',
                '2815cc6561a19adbf64098350ceca53f',
                '0e2f6d1133c650ec64e7d20e7c6686eb',
                'ed598487d90558f867a5e0b2e9a66655',
                '3e0b619bac84457a7589091d32c60a93',
                '1a6bc0f6ab34f11fbe95a5a3b1835a36',
                'adbbb9aec632da7c7a3c4470d183d7dd',
                '91b3f9f7a21e9f72247b074b12e4c7a6',
                '831612175f2e92c9aaffa360ff829bcf',
                'e42b11a20b1f38ec9d42cbb8e4ff2b74',
                '8ee923e0a4cf01cfef7e0ce8cf7b5729',
                '6d2bffaf965354e1e9b456ff09ac1ac6',
                'f027aa15b35946fc2502cbd76550f9ca',
                '6a18140e7490269cdd0fc4bbf3255278',
            ],
        },
        {
            viewtag: '55966deb46528f951ad5bd99ee6d15a7',
            viewmodule: 'wkd',
            viewname: 'WoServiceSuperviseEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '59dc621409a73d07094c660eb0f26385',
            viewmodule: 'wkd',
            viewname: 'WoSpareInfoEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '6083f24de3a3be6f96390b11881aba06',
            viewmodule: 'wkd',
            viewname: 'WoMeasureEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '61451de2399645a6f0bac4a3185248f3',
            viewmodule: 'wkd',
            viewname: 'WoTechSupportGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'd0b3d2ec198ef1294d8ad33855df6e00',
            ],
        },
        {
            viewtag: '6649103bdf9465e168c517a9a0d75380',
            viewmodule: 'wkd',
            viewname: 'WoWechatInfoGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'fcb52c1620bd3ec95a33347425ffe7c2',
            ],
        },
        {
            viewtag: '665c668be0f2eb77a97308f06d3ffe8a',
            viewmodule: 'smt',
            viewname: 'WoSmVisitTaskUsr5EditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'c82ed99fa1d6703caecafc28434d6dc9',
            ],
        },
        {
            viewtag: '66e083bfe46d2e2bd27f57392965461d',
            viewmodule: 'wkd',
            viewname: 'WoMaterialDetailedEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '6a18140e7490269cdd0fc4bbf3255278',
            viewmodule: 'smt',
            viewname: 'WoSmInfoSmInfoAgentGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '3a058e620932eb84d4d6e60e6f8931e9',
            ],
        },
        {
            viewtag: '6bf8bf89acdef079d2ef3bf5dc1a9d22',
            viewmodule: 'wkd',
            viewname: 'WoProdUsr5GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'ce9432ad2176d15650482de6c093f1b3',
            ],
        },
        {
            viewtag: '6cb78195a9556c14b133e4b0010f35bb',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderUsr8GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '03309023e72ec42a0df67de1698b013e',
            ],
        },
        {
            viewtag: '6d2bffaf965354e1e9b456ff09ac1ac6',
            viewmodule: 'smt',
            viewname: 'WoSmVisitTaskUsr2EditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '500ae2900da9f583d75f6b130052e465',
                'de87316d78cee9daabd32e95af6917d7',
                '4564cf64854f382d4593c381fad98d9d',
            ],
        },
        {
            viewtag: '6ff0e2a9de9833b55b93eacb3337811a',
            viewmodule: 'wkd',
            viewname: 'WoProjectApprovalGridView_Product',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '9a40b105336af2bad813b24924438624',
            ],
        },
        {
            viewtag: '71d8ba694acfa4f070a9b992d34379a4',
            viewmodule: 'wkd',
            viewname: 'WoSerialCheckGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '9657efc0ae119d05c6c0b4f772e62a46',
            ],
        },
        {
            viewtag: '7233ba909c69c9be52f7329658736d81',
            viewmodule: 'smt',
            viewname: 'WoSmStimulateFileUploadEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '79e6fd53665e34c79195010bae3238a5',
            viewmodule: 'wkd',
            viewname: 'WoMessageInfoGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '14b84cf2d196dbbbba2ab3864eb6d12b',
                '0e2f6d1133c650ec64e7d20e7c6686eb',
            ],
        },
        {
            viewtag: '7b5cb08b4bee366b659dc2c4517b1144',
            viewmodule: 'wkd',
            viewname: 'WoProdGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'ce9432ad2176d15650482de6c093f1b3',
            ],
        },
        {
            viewtag: '7bc4b408f618f18fec28584729e25f3b',
            viewmodule: 'bdt',
            viewname: 'BdNetEmpDataEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '817be7891afd2adb7109c77c1d8af647',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderPickupGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'a1863f3a17f6d72856c9e2af55d4294a',
            ],
        },
        {
            viewtag: '8192e04799f4b0d072ca577ebe34b50b',
            viewmodule: 'smt',
            viewname: 'WoSmVisitRuleEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '91b3f9f7a21e9f72247b074b12e4c7a6',
            ],
        },
        {
            viewtag: '81f2d4928d038339a935ab3028a2a2b7',
            viewmodule: 'bdt',
            viewname: 'BdProjectUsr2GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'd44a1d790472b304b8957d54d95e177e',
            ],
        },
        {
            viewtag: '8234a596c7a9941e5bdd04dd26480190',
            viewmodule: 'smt',
            viewname: 'WoSmSurchargesEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '831612175f2e92c9aaffa360ff829bcf',
            viewmodule: 'smt',
            viewname: 'WoSmSurchargesOtherApplyEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '32e94148efa844fb2e0ba14d034cd2d4',
            ],
        },
        {
            viewtag: '8a30070e5e5e6f69d1b31baac242d239',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderInternalGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '9c29fdabf6bee510e00b282ddef834c4',
                '03309023e72ec42a0df67de1698b013e',
            ],
        },
        {
            viewtag: '8ee923e0a4cf01cfef7e0ce8cf7b5729',
            viewmodule: 'wkd',
            viewname: 'WoProjectWordsGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'd38f49c5f2bff569da0cd7f85ed4ce66',
            ],
        },
        {
            viewtag: '915b297129e22edff6e14b236e1d3b03',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderSmInfoGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'a1863f3a17f6d72856c9e2af55d4294a',
                '03309023e72ec42a0df67de1698b013e',
            ],
        },
        {
            viewtag: '91b3f9f7a21e9f72247b074b12e4c7a6',
            viewmodule: 'wkd',
            viewname: 'WoSmVisitRuleGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '8192e04799f4b0d072ca577ebe34b50b',
            ],
        },
        {
            viewtag: '94603bf6757991866089cb6af7ffd074',
            viewmodule: 'wkd',
            viewname: 'WoCallInfoEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '96523692fba247175f97d566c7f469c3',
            viewmodule: 'smt',
            viewname: 'WoSmVisitTaskUsr3EditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'a5b7f0d3c695d834331abfeb3a241834',
            ],
        },
        {
            viewtag: '9657efc0ae119d05c6c0b4f772e62a46',
            viewmodule: 'wkd',
            viewname: 'WoSerialCheckEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '97e8aa4565ee59f15cfa6cfc2d7da69a',
            viewmodule: 'wkd',
            viewname: 'WoClientContactEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: '9a40b105336af2bad813b24924438624',
            viewmodule: 'wkd',
            viewname: 'WoProjectApprovalEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '9fd46b2e067e52b3893ac9db660f0c0b',
                '6ff0e2a9de9833b55b93eacb3337811a',
            ],
        },
        {
            viewtag: '9a4fe62fb7e5da7f2ff10f9eb790cef7',
            viewmodule: 'bdt',
            viewname: 'BdUserAssetArchievesUsr2GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '0e65c6512b8018de3acb5f5a006e0c6a',
            ],
        },
        {
            viewtag: '9c29fdabf6bee510e00b282ddef834c4',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderUsr5EditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '7b5cb08b4bee366b659dc2c4517b1144',
                'ac994ca812e1a01ffa3bf4a722abaf3c',
                'a1863f3a17f6d72856c9e2af55d4294a',
                '2cdd13d27ddaf16f6d85680b39accdf0',
            ],
        },
        {
            viewtag: '9d387db2e72535e11a5e3a65a7a6cecf',
            viewmodule: 'wkd',
            viewname: 'WoSmSurchargesSurchagesGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '8234a596c7a9941e5bdd04dd26480190',
            ],
        },
        {
            viewtag: '9fd46b2e067e52b3893ac9db660f0c0b',
            viewmodule: 'wkd',
            viewname: 'WoProjectApprovalEditView_Approval',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'e98602dcde417da61bcb5741b1e396de',
            ],
        },
        {
            viewtag: 'a06dedb0979c28d6243c7fff309eb5d2',
            viewmodule: 'wkd',
            viewname: 'WoProjectApprovalGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '9a40b105336af2bad813b24924438624',
                'd44a1d790472b304b8957d54d95e177e',
            ],
        },
        {
            viewtag: 'a1863f3a17f6d72856c9e2af55d4294a',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderUsr3EditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'df51f54510ecd25a48de90f4e9c713cf',
                '7b5cb08b4bee366b659dc2c4517b1144',
                'f2736129047dc68f284041f89f8e1316',
                'e85c0c8093c35fd1200fa9aa656b2c5c',
                'ac994ca812e1a01ffa3bf4a722abaf3c',
                'f4b4a57498869fc6d7b23778bb83475f',
                '2cdd13d27ddaf16f6d85680b39accdf0',
                '5018f179ea8c1791b1fcad1e329f0fbe',
                '1919d66c4c7c514cec8f5ea02c888f43',
                'b9a271b37b829ce46459be5ac2315c64',
            ],
        },
        {
            viewtag: 'a5b7f0d3c695d834331abfeb3a241834',
            viewmodule: 'smt',
            viewname: 'WoSmVisitTaskUsr5GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'a6226fc59dde799b838540cd30acafa7',
            viewmodule: 'wkd',
            viewname: 'WoApprovalHistoryGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'c202c43ebe249232fabc8a544aef081f',
            ],
        },
        {
            viewtag: 'a6484523e3cf8b297dc197c3c5362348',
            viewmodule: 'wkd',
            viewname: 'WoSpareInfoUsr3GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '59dc621409a73d07094c660eb0f26385',
            ],
        },
        {
            viewtag: 'a6503c88a8ce448eea4d15e5bd2ed191',
            viewmodule: 'wkd',
            viewname: 'BdCustomerPickupView2',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '244200b1f065659f0fb553e4f7974d17',
            ],
        },
        {
            viewtag: 'a743fc83f49be525940bdc842076f940',
            viewmodule: 'smt',
            viewname: 'WoSmSurchargesOtherSkipEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'a9054140ee5a7f6eb5ec8f0f86768687',
            viewmodule: 'smt',
            viewname: 'WoSmStimulateUsr3GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'b9e8181396c15df37c58a532cb8fd50d',
            ],
        },
        {
            viewtag: 'a968d96a82ca712efd9f6b0d17742cbb',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderAddRelatedUserEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'a6503c88a8ce448eea4d15e5bd2ed191',
            ],
        },
        {
            viewtag: 'ab11dd123b98c06421dcb72ec109eab5',
            viewmodule: 'wkd',
            viewname: 'WoSerialNumberEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'eba4b1b6deefa310271ce8c9a68dcbb8',
                'a6226fc59dde799b838540cd30acafa7',
                'c4370c0c8adb9d0003db39fbc8d808c9',
                'd157d1e147d402ca8c6fc1b729b4088a',
            ],
        },
        {
            viewtag: 'ab92960e171e985d50aae9e7e29d0c9f',
            viewmodule: 'smt',
            viewname: 'WoSmTicketEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '2e41d1fde62f9bc93987fa2287bb14a7',
            ],
        },
        {
            viewtag: 'ac2c0be8d0abd3b33efff8d6a5c2142a',
            viewmodule: 'smt',
            viewname: 'WoSmSurchargesSurchargesAgentGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '8234a596c7a9941e5bdd04dd26480190',
            ],
        },
        {
            viewtag: 'ac994ca812e1a01ffa3bf4a722abaf3c',
            viewmodule: 'wkd',
            viewname: 'WoProcessHistoryUsr2GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '2324959ee82cea859dc4f82342991e38',
                'bfc401004306ea33b92652f287426f8d',
            ],
        },
        {
            viewtag: 'adbbb9aec632da7c7a3c4470d183d7dd',
            viewmodule: 'wkd',
            viewname: 'WoServiceTypeGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'e0ac4eb47db23db3bda4661b0ca9e090',
            ],
        },
        {
            viewtag: 'ade28c7624eda179a621c29515511b81',
            viewmodule: 'wkd',
            viewname: 'WoProdPickupView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'bedfacbe2f70c340aad804e7ba3816a8',
            ],
        },
        {
            viewtag: 'b1e735452b86e7aa6ade7afc476e39f9',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderSmInfoAgentGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '03309023e72ec42a0df67de1698b013e',
            ],
        },
        {
            viewtag: 'b27cec60bcf15a1d271214405714efc5',
            viewmodule: 'smt',
            viewname: 'WoSmVisitResultUsr2EditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'd5ab11ea0847a5e93feaa46b2370c9e3',
            ],
        },
        {
            viewtag: 'b5e161e5ef5596fdbbb066dda65fb93b',
            viewmodule: 'smt',
            viewname: 'WoSmClaimsInfoBasicGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '2815cc6561a19adbf64098350ceca53f',
            ],
        },
        {
            viewtag: 'b9911706fa7bd07b1c85a897682216ec',
            viewmodule: 'wkd',
            viewname: 'WoMeasureUsr3GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '6083f24de3a3be6f96390b11881aba06',
            ],
        },
        {
            viewtag: 'b9a271b37b829ce46459be5ac2315c64',
            viewmodule: 'wkd',
            viewname: 'WoMeasureUsr2GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '6083f24de3a3be6f96390b11881aba06',
                '052de6cc43f3333159d35381c8150133',
            ],
        },
        {
            viewtag: 'b9e8181396c15df37c58a532cb8fd50d',
            viewmodule: 'smt',
            viewname: 'WoSmStimulateEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '381cd6bff30cbf2aa0df3c9c11f30a2c',
            ],
        },
        {
            viewtag: 'bedfacbe2f70c340aad804e7ba3816a8',
            viewmodule: 'wkd',
            viewname: 'WoProdPickupGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'bfc401004306ea33b92652f287426f8d',
            viewmodule: 'wkd',
            viewname: 'WoProcessHistoryEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'c202c43ebe249232fabc8a544aef081f',
            viewmodule: 'wkd',
            viewname: 'WoApprovalHistoryEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'c4370c0c8adb9d0003db39fbc8d808c9',
            viewmodule: 'wkd',
            viewname: 'WoProdUsr4GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'ce9432ad2176d15650482de6c093f1b3',
            ],
        },
        {
            viewtag: 'c82ed99fa1d6703caecafc28434d6dc9',
            viewmodule: 'smt',
            viewname: 'WoSmVisitTaskUsr7GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'cce7be02b8c2e542c7553397013e8bd6',
            viewmodule: 'wkd',
            viewname: 'WoSerialNumberGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'ab11dd123b98c06421dcb72ec109eab5',
            ],
        },
        {
            viewtag: 'ccef7528f013b8bb6aa49b8d91fb3457',
            viewmodule: 'smt',
            viewname: 'WoSmClaimsGoodsEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'ce9432ad2176d15650482de6c093f1b3',
            viewmodule: 'wkd',
            viewname: 'WoProdEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '3c01c80f3ec22a05d4177246580084e1',
            ],
        },
        {
            viewtag: 'd0b3d2ec198ef1294d8ad33855df6e00',
            viewmodule: 'wkd',
            viewname: 'WoTechSupportEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'd0bf680f5378d11aff029395886c8b0f',
            viewmodule: 'wkd',
            viewname: 'WoDistributeFactorEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'd157d1e147d402ca8c6fc1b729b4088a',
            viewmodule: 'wkd',
            viewname: 'WoApprovalHistoryUsr2EditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'd38f49c5f2bff569da0cd7f85ed4ce66',
            viewmodule: 'wkd',
            viewname: 'WoProjectWordsEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'd44a1d790472b304b8957d54d95e177e',
            viewmodule: 'wkd',
            viewname: 'BdProjectEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'd5ab11ea0847a5e93feaa46b2370c9e3',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderUsr7EditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '6bf8bf89acdef079d2ef3bf5dc1a9d22',
                'f4b4a57498869fc6d7b23778bb83475f',
                'a6484523e3cf8b297dc197c3c5362348',
                '19879b6e59b9477a0279bbb0f0b45481',
                'b9911706fa7bd07b1c85a897682216ec',
                '6cb78195a9556c14b133e4b0010f35bb',
                '5343f8a488c42f2371bff99be1bf3701',
            ],
        },
        {
            viewtag: 'de87316d78cee9daabd32e95af6917d7',
            viewmodule: 'smt',
            viewname: 'WoSmVisitTaskUsr3GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '96523692fba247175f97d566c7f469c3',
                '665c668be0f2eb77a97308f06d3ffe8a',
            ],
        },
        {
            viewtag: 'df51f54510ecd25a48de90f4e9c713cf',
            viewmodule: 'wkd',
            viewname: 'WoOtherPaidServicesUsr2GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'e6a09cbb724e63aa0aa45412dab2114a',
            ],
        },
        {
            viewtag: 'e0ac4eb47db23db3bda4661b0ca9e090',
            viewmodule: 'wkd',
            viewname: 'WoServiceTypeEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'e42b11a20b1f38ec9d42cbb8e4ff2b74',
            viewmodule: 'smt',
            viewname: 'WoSmStimulateAppealInfoGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '1a6bc0f6ab34f11fbe95a5a3b1835a36',
                'b9e8181396c15df37c58a532cb8fd50d',
                '3a27294878f2839cd20ab3d30e1acbed',
            ],
        },
        {
            viewtag: 'e6a09cbb724e63aa0aa45412dab2114a',
            viewmodule: 'wkd',
            viewname: 'WoOtherPaidServicesEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'e85c0c8093c35fd1200fa9aa656b2c5c',
            viewmodule: 'bdt',
            viewname: 'BdNetEmpDataUsr2GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '7bc4b408f618f18fec28584729e25f3b',
            ],
        },
        {
            viewtag: 'e90c9767da6c3887a4775b1d2edcb42d',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderUsr7GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '03309023e72ec42a0df67de1698b013e',
                'b27cec60bcf15a1d271214405714efc5',
            ],
        },
        {
            viewtag: 'e98602dcde417da61bcb5741b1e396de',
            viewmodule: 'wkd',
            viewname: 'WoProjectApprovalGridView_ApprovalHistory',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '9a40b105336af2bad813b24924438624',
            ],
        },
        {
            viewtag: 'eaa3d8c1504ff9323b3a9b04339a938c',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderServiceInProcessGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'a1863f3a17f6d72856c9e2af55d4294a',
                '03309023e72ec42a0df67de1698b013e',
            ],
        },
        {
            viewtag: 'eba4b1b6deefa310271ce8c9a68dcbb8',
            viewmodule: 'wkd',
            viewname: 'WoProdUsr3GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'ce9432ad2176d15650482de6c093f1b3',
            ],
        },
        {
            viewtag: 'ebaf4b76909b521b9bef4e9f4f5b94e3',
            viewmodule: 'smt',
            viewname: 'WoSmInfoSmInfoEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '915b297129e22edff6e14b236e1d3b03',
                '9d387db2e72535e11a5e3a65a7a6cecf',
                'a9054140ee5a7f6eb5ec8f0f86768687',
            ],
        },
        {
            viewtag: 'ed598487d90558f867a5e0b2e9a66655',
            viewmodule: 'wkd',
            viewname: 'WoCallInfoGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '94603bf6757991866089cb6af7ffd074',
                '0e2f6d1133c650ec64e7d20e7c6686eb',
            ],
        },
        {
            viewtag: 'f027aa15b35946fc2502cbd76550f9ca',
            viewmodule: 'wkd',
            viewname: 'WoDistributeFactorGridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                'd0bf680f5378d11aff029395886c8b0f',
            ],
        },
        {
            viewtag: 'f2736129047dc68f284041f89f8e1316',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderUsr6EditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
        {
            viewtag: 'f36b235f97cf06984864f4d32e9f3bdf',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderUsr3GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '03309023e72ec42a0df67de1698b013e',
            ],
        },
        {
            viewtag: 'f4b4a57498869fc6d7b23778bb83475f',
            viewmodule: 'wkd',
            viewname: 'WoWorkOrderUsr4GridView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
                '03309023e72ec42a0df67de1698b013e',
            ],
        },
        {
            viewtag: 'fcb52c1620bd3ec95a33347425ffe7c2',
            viewmodule: 'wkd',
            viewname: 'WoWechatInfoEditView',
            viewaction: '',
            viewdatachange: false,
            refviews: [
            ],
        },
    ],
    createdviews: [],
}